<template>
  <div class="">
    <div v-if="isLoading" class="spinner-overlay">
      <div class="spinner-border" role="status">
        <span class="visually-hidden">Loading...</span>
      </div>
    </div>
    <div class="table-container" :id="'table' + idindex">
      <table class="ms-table table table-sm">
        <thead class="sticky-header" @click="onHeaderClick">
          <tr>
            <th class="sort" data-sort="spare-name " scope="col">
              <a href="#" class="text-body-secondary list-sort sticky-header">Spare Name </a>
            </th>
            <th class="sort" data-sort="location" scope="col">
              <a href="#" class="text-body-secondary list-sort sticky-header">Location </a>
            </th>
            <th class="sort" data-sort="sub-category" scope="col">
              <a href="#" class="text-body-secondary list-sort sticky-header">Subcategory </a>
            </th>
            <th class="sort" data-sort="desc" scope="col">
              <a href="#" class="text-body-secondary list-sort sticky-header">Description </a>
            </th>
            <th class="sort" data-sort="ident-number" scope="col">
              <a href="#" class="text-body-secondary list-sort sticky-header">Ident. Number </a>
            </th>
            <th class="sort" data-sort="customer-doc-ref-no" scope="col">
              <a href="#" class="text-body-secondary list-sort sticky-header"
                >Customer doc/ref no.</a
              >
            </th>
            <th class="sort" data-sort="customer-bar-code" scope="col">
              <a href="#" class="text-body-secondary list-sort">Customer Bar code.</a>
            </th>
            <th class="sort" data-sort="nkt-bar-code" scope="col">
              <a href="#" class="text-body-secondary list-sort sticky-header">NKT Bar code</a>
            </th>
            <th class="sort" data-sort="position" scope="col">
              <a href="#" class="text-body-secondary list-sort sticky-header">Position </a>
            </th>
            <th class="sort" data-sort="box-pallet-no" scope="col">
              <a href="#" class="text-body-secondary list-sort sticky-header">Box/Pallet no.</a>
            </th>
            <th class="sort" data-sort="box-pallet-label" scope="col">
              <a href="#" class="text-body-secondary list-sort sticky-header">Box/ Pallet Label</a>
            </th>
            <th class="sort" data-sort="quantity" scope="col">
              <a href="#" class="text-body-secondary list-sort sticky-header">Quantity </a>
            </th>
            <th class="sort" data-sort="unit" scope="col">
              <a href="#" class="text-body-secondary list-sort sticky-header">Unit </a>
            </th>
            <th class="sort" data-sort="po-ref-no" scope="col">
              <a href="#" class="text-body-secondary list-sort sticky-header">PO refrence no.</a>
            </th>
            <th class="sort" data-sort="delivery-date" scope="col">
              <a href="#" class="text-body-secondary list-sort sticky-header">Delivery Date </a>
            </th>
            <th class="sort" data-sort="delivery-cert-no" scope="col">
              <a href="#" class="text-body-secondary list-sort sticky-header"
                >Delivery certificate no.</a
              >
            </th>
            <th class="sort" data-sort="Manufacturer" scope="col">
              <a href="#" class="text-body-secondary list-sort sticky-header">Manufacturer</a>
            </th>
            <th class="sort" data-sort="expiry-date" scope="col">
              <a href="#" class="text-body-secondary list-sort sticky-header">Expiry Date </a>
            </th>
            <th class="sort" data-sort="last-inspection-by" scope="col">
              <a href="#" class="text-body-secondary list-sort sticky-header"
                >Last inspection by
              </a>
            </th>
            <th class="sort" data-sort="last-inspection" scope="col">
              <a href="#" class="text-body-secondary list-sort sticky-header">Last inspection </a>
            </th>
            <th class="sort" data-sort="next-inspection" scope="col">
              <a href="#" class="text-body-secondary list-sort sticky-header">Next inspection </a>
            </th>
            <th class="sort" data-sort="storage-description" scope="col">
              <a href="#" class="text-body-secondary list-sort sticky-header"
                >Storage Description
              </a>
            </th>
            <th class="sort" data-sort="custom-lead-time" scope="col">
              <a href="#" class="text-body-secondary list-sort sticky-header">Custom Lead Time</a>
            </th>
            <th class="sort" data-sort="notes" scope="col">
              <a href="#" class="text-body-secondary list-sort sticky-header">Notes</a>
            </th>
          </tr>
        </thead>
        <tbody class="list" v-if="!isLoading">
          <tr class="ms-row" v-for="(sparepart, idx) in sortedSpareparts" :key="`${sparepart.identity}-${sparepart.position}-${idx}`">
            <td class="spare-name" nowrap>
              {{ sparepart.spareName }}
            </td>
            <td class="location" nowrap>
              {{ sparepart.location }}
            </td>
            <td class="sub-category" nowrap>
              {{ sparepart.subcategory }}
            </td>
            <td class="desc" nowrap>
              {{ sparepart.description }}
            </td>
            <td class="ident-number" nowrap scope="row">
              {{ sparepart.identity }}
            </td>
            <td class="customer-doc-ref-no" nowrap>
              {{ sparepart.customerDocNo }}
            </td>
            <td class="customer-bar-code" nowrap>
              {{ sparepart.cusotmerBarCode }}
            </td>
            <td class="nkt-bar-code" nowrap>
              {{ sparepart.nktBarCode }}
            </td>
            <td class="position">
              {{ sparepart.position }}
            </td>

            <td class="box-pallet-no">
              {{ sparepart.boxPalletNo }}
            </td>
            <td class="box-pallet-label">
              {{ sparepart.boxPalletLabel }}
            </td>
            <td class="quantity">
              {{ sparepart.quantity }}
            </td>
            <td class="unit">
              {{ sparepart.unit }}
            </td>
            <td class="po-ref-noit">
              {{ sparepart.poRefeNo }}
            </td>
            <td class="delivery-date" nowrap>
              {{ formatTimestamp(sparepart.deliveryDate) }}
            </td>
            <td class="delivery-cert-no">
              {{ sparepart.deliveryCertNo }}
            </td>
            <td class="manufacturer">
              {{ sparepart.manufacturer }}
            </td>
            <td class="expiry-date" nowrap :class="{ 'expired-date-cell': sparepart.isExpired }">
              {{ sparepart.expiryDate ? formatTimestamp(sparepart.expiryDate) : 'No Limit' }}
            </td>
            <td class="last-inspection-by" nowrap>
              {{ sparepart.lastInspectionBy }}
            </td>
            <td class="last-inspection" nowrap>
              {{ formatTimestamp(sparepart.lastInspection) }}
            </td>
            <td class="next-inspection" nowrap>
              {{ formatTimestamp(sparepart.nextInspection) }}
            </td>
            <td class="storage-description" nowrap>
              {{ sparepart.storageDescription }}
            </td>
            <td class="storage-description" nowrap>
              {{ sparepart.customLeadTime }}
            </td>
            <td class="notes" nowrap>
              {{ sparepart.notes }}
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script setup lang="ts">
import { SparePart } from '@/server/MakeSenseApp-backend'
import moment from 'moment'
import { defineProps, ref, computed } from 'vue'
import '@/styles/ms-table-styles.scss'

const props = defineProps({
  spareparts: Array<SparePart>,
  isLoading: Boolean,
  idindex: Number
})

const formatTimestamp = (timestamp: Date | undefined): string => {
  if (!timestamp) return '-'
  return moment(timestamp).format('YYYY-MM-DD')
}

const sortKey = ref('sub-category')
const sortOrder = ref<'asc' | 'desc'>('asc')

function toggleSort(key: string) {
  if (sortKey.value === key) {
    sortOrder.value = sortOrder.value === 'asc' ? 'desc' : 'asc'
  } else {
    sortKey.value = key
    sortOrder.value = 'asc'
  }
}

function onHeaderClick(e: MouseEvent) {
  e.preventDefault()
  const th = (e.target as HTMLElement).closest('th[data-sort]') as HTMLElement | null
  if (th?.dataset.sort) toggleSort(th.dataset.sort)
}

const sortedSpareparts = computed(() => {
  return [...(props.spareparts ?? [])].sort((a, b) => {
    switch (sortKey.value) {
      case 'quantity':
        return sortOrder.value === 'asc'
          ? Number(a.quantity ?? 0) - Number(b.quantity ?? 0)
          : Number(b.quantity ?? 0) - Number(a.quantity ?? 0)
      case 'delivery-date':
      case 'expiry-date':
      case 'last-inspection':
      case 'next-inspection': {
        const dateFieldMap: Record<string, string> = {
          'delivery-date': 'deliveryDate',
          'expiry-date': 'expiryDate',
          'last-inspection': 'lastInspection',
          'next-inspection': 'nextInspection'
        }
        const field = dateFieldMap[sortKey.value]
        const aTime = ((a as any)[field] as Date | undefined)?.getTime() ?? 0
        const bTime = ((b as any)[field] as Date | undefined)?.getTime() ?? 0
        return sortOrder.value === 'asc' ? aTime - bTime : bTime - aTime
      }
      default: {
        const strFieldMap: Record<string, string> = {
          'spare-name': 'spareName',
          'location': 'location',
          'sub-category': 'subcategory',
          'desc': 'description',
          'ident-number': 'identity',
          'customer-doc-ref-no': 'customerDocNo',
          'customer-bar-code': 'cusotmerBarCode',
          'nkt-bar-code': 'nktBarCode',
          'position': 'position',
          'box-pallet-no': 'boxPalletNo',
          'box-pallet-label': 'boxPalletLabel',
          'unit': 'unit',
          'po-ref-no': 'poRefeNo',
          'delivery-cert-no': 'deliveryCertNo',
          'Manufacturer': 'manufacturer',
          'last-inspection-by': 'lastInspectionBy',
          'storage-description': 'storageDescription',
          'custom-lead-time': 'customLeadTime',
          'notes': 'notes'
        }
        const field = strFieldMap[sortKey.value] ?? 'spareName'
        const aVal = String((a as any)[field] ?? '')
        const bVal = String((b as any)[field] ?? '')
        const cmp = aVal.localeCompare(bVal)
        return sortOrder.value === 'asc' ? cmp : -cmp
      }
    }
  })
})
</script>

<style scoped>
.table-container {
  overflow-y: auto;
  overflow-x: auto;
}

.expired-date-cell {
  background-color: #ffd4bb;
}

.sticky-header {
  position: sticky;
  top: 0;
  z-index: 1000; /* Ensure it stays on top of accordion rows */
  background-color: white; /* Prevent transparency when scrolling */
}

.table-container {
  max-height: 500px;
  overflow-y: auto;
  overflow-x: auto;
}
</style>
